class BaseMultishipForm extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this._initialized = false;
    this.handlesTaxes = false;
    this.apiBaseUrl = "https://prod.lcftools.com";
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.initialize();
  }

  initialize() {
    this.lineItemId = this.getAttribute("data-line-item-id");
    this.loadData();
    this.render();
  }

  iconCirclePlus(option) {
    let color;
    switch (option) {
      case "gray":
        color = "#D9D9D9";
        break;
      default:
        color = "#53613C";
    }

    return `
      <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="34" height="35" rx="17" fill="${color}"/>
        <path d="M16.0338 21.128V17.366H12.2898V16.466H16.0338V12.704H16.9698V16.466H20.7138V17.366H16.9698V21.128H16.0338Z" fill="white"/>
      </svg>
    `;
  }

  baseMultishipFormStyles() {
    return `
      <style>
        :root {
          --gray-light: #F9F9F9;
          --gray-medium: #D9D9D9;
          --red-medium: #891b1c;
        }
        
        * { 
          box-sizing: border-box;
          letter-spacing: 0;
        }

        .multiship__section {
          background: #fff;
          border: 1px solid var(--gray-medium);
          padding: 2rem;
          flex-grow: 1;
        }

        .multiship__header {
          display: flex;
          gap: 1rem;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 1rem;
        }

        .multiship__header h4 {
          margin: 0;
          font-weight: 600;
          font-size: 16px;
          line-height: 1.15
        }

        .multiship-form {
          container-type: inline-size;
        }

        .multiship-form__inputs {
          display: grid;
          gap: 8px;
          margin: 1.6rem 0;  
        }

        .multiship-form label {
          font-size: 1.2rem;
        }
        
        @container (min-width: 280px) {
          .multiship-form__inputs {
            grid-template-columns: repeat(6, 1fr);
          }
          .saved-addresses { grid-column: span 6;}
          .first-name { grid-column: span 3; }
          .last-name { grid-column: span 3; }
          .company { grid-column: span 6; }
          .address-1 { grid-column: span 6; }
          .address-2 { grid-column: span 6; }
          .city { grid-column: span 6; }
          .state-province { grid-column: span 3 }
          .zip { grid-column: span 3; }
          .country-code { grid-column: span 6 }
          .shipping-method,
          .ship-date { grid-column: span 6; } 
        }
          
        @container (min-width: 480px) {
          .first-name { grid-column: span 2; }
          .last-name { grid-column: span 4; }
          .state-province { grid-column: span 2;}
          .zip { grid-column: span 2; }
          .country-code { grid-column: span 2;}
        }


        .multiship__actions {
          display: flex;
          gap: 1rem;
          align-items: center;
        }
        
        input:not([type="radio"], [type="checkbox"]),
        select,
        textarea { 
          display: block; 
          width: 100%; 
          padding: 8px; 
          border: 1px solid rgba(24,24,24,.25);
          border-radius: 4px;
          background: #fff;
          font-size: 16px;
        }

        select {
          height: 51px;
        }

        textarea {
          resize: vertical;
        }

        input:not([type="radio"], [type="checkbox"]):is(:disabled, :readonly),
        select:is(:disabled, :readonly),
        textarea:is(:disabled, :readonly) { 
          opacity: 0.75;
          cursor: not-allowed;
        }

        .error-message {
          color: #891b1c;
          font-size: 1.1rem;
        }

        .form-field:has(.error-message) :is(input:not([type="radio"], [type="checkbox"]), select, textarea) {
          border-color: #891b1c;
        }

        .gift-message-form__main {
          margin-bottom: 1.6rem;
        }

        .button {
          border: none;
          box-shadow: 0 0 0 0 transparent;
          cursor: pointer;
          font-weight: 500;
          text-align: center;
          transition: background 0.2s ease-in-out;
          padding: 0.5em 2em;
          font-family: inherit;
          background-color: rgba(var(--color-button),var(--alpha-button-background));
          color: rgb(var(--color-button-text));
          font-size: 1.5rem;
          letter-spacing: .1rem;
          border-radius: var(--buttons-radius-outset);
          position: relative
        }

        .button:after,
        .shopify-challenge__button:after,
        .customer button:after,
        .shopify-payment-button__button--unbranded:after {
          content: '';
          position: absolute;
          top: var(--buttons-border-width);
          right: var(--buttons-border-width);
          bottom: var(--buttons-border-width);
          left: var(--buttons-border-width);
          z-index: 1;
          border-radius: var(--buttons-radius);
          box-shadow: 0 0 0 calc(var(--buttons-border-width) + 0.3px)
              rgba(var(--color-button-text), var(--border-opacity)),
            0 0 0 var(--buttons-border-width) rgba(var(--color-button), var(--alpha-button-background));
          transition: box-shadow var(--duration-short) ease;
        }
        
        .button--secondary,
        .button--tertiary {
          --color-button: var(--color-secondary-button);
          --color-button-text: var(--color-secondary-button-text);
        }

        .button--secondary:after {
          --border-opacity: var(--buttons-border-opacity);
        }
        
        .button--full-width {
          display: flex;
          width: 100%;
          justify-content: center;
        }

        .link-button {
          background: none; 
          color: var(--color-foreground);
          text-decoration: underline;
          cursor: pointer;
          appearance: none;
          border: none;
          padding: 0;
          opacity: 0.75;
        }
        .link-button--danger {
          color: #891b1c;
        }
        .link-button:hover {
          opacity: 1;
        }

        .multiship__button,
        .bundle-recipients__button { 
          appearance: none;
          display: flex;
          align-items: center;
          justify-content: start;
          gap: 1em;
          width: 100%;
          background: #fff;
          border: 1px solid var(--gray-medium);
          cursor: pointer;
          padding: 2rem;
          font-size: 1.4rem;
          line-height: 1.5;
        }

        .multiship__button svg,
        .bundle-recipients__button svg {
          flex-shrink: 0;
        } 

        .multiship__button--disabled {
          cursor: not-allowed;
        }


        .multiship__button:not(.multiship__button--disabled):hover {
          border-color: var(--color-button);
        }

        @container (min-width: 800px) {
          .multiship__button,
          .bundle-recipients__button {
            font-size: 1.6rem;
            padding: 3rem 2rem;
            justify-content: center;
          }
        }

        .helper {
          font-size: 1.4rem;
          color: var(--color-foreground);
        }

        .multiship-dl {

        }

        .multiship-dl--horizontal {
          display: flex;
          flex-wrap: wrap;
          column-gap: 1.6rem;
          row-gap: 1rem;
        }

        .multiship-dl dt {
          font-size: 1.2rem;
        }
        .multiship-dl dd {
          margin: 0;
        }
        .multiship-dl dd + dt {
          margin-top: 1rem;
        }

        .u-text-center {
          text-align: center !important;
        }

        .helper {
          line-height: 1.4;
        }

        .floating-label {
          position: relative;
        }

        .floating-label label {
          position: absolute;
          top: 1rem;
          left: 0.8rem;
          font-size: 1.6rem;
          transition: all 0.2s;
        }

        .floating-label :is(input, select, textarea) {
          padding-top: 2rem;
        }

        .floating-label:has(input:not(:placeholder-shown)) label,
        .floating-label:has(input:focus) label,
        .floating-label:has(option:checked) label {
          font-size: 1.2rem;
          top: 0.2rem;
        }

        .full-address-label {
          display: block;
          padding: 0.8rem;
          background: rgba(var(--color-foreground), 0.02);
        }

        .address-option:not(:last-child) {
          margin-bottom: 1.6rem;
        }

        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }

        .multiship__section--error {
          border: 2px solid #dc3545;
          padding: 1.5rem;
          border-radius: 4px;
          background-color: #fff;
        }

        .multiship__section--error h4 {
          color: #dc3545;
          margin-bottom: 1rem;
        }

        .multiship__section--error p {
          margin-bottom: 1.5rem;
        }
      </style>
    `;
  }

  loadData() {
    const propertiesString = this.getAttribute("data-item-properties");

    if (!propertiesString) {
      this.setDefaultValues();
      return;
    }

    try {
      // The browser has already decoded the escaped Liquid attribute. Decode
      // property values only after parsing so entities such as &quot; cannot
      // invalidate the JSON string.
      this.properties = this.decodeAllProperties(
        JSON.parse(propertiesString),
      );

      // Keep a copy of original properties for bundle field preservation
      this.originalProperties = JSON.parse(JSON.stringify(this.properties));

      // Store the normalized serialized values so later form updates do not
      // re-submit an HTML-encoded version of an unchanged property.
      const dataProp = this.properties.find((prop) => prop[0] === "_data");
      if (dataProp && dataProp[1]) {
        this.dataString = dataProp[1];
      } else {
        this.dataString = null;
      }

      const taxRatesProp = this.properties.find(
        (prop) => prop[0] === "_taxRates",
      );
      if (taxRatesProp && taxRatesProp[1]) {
        this.taxRatesString = taxRatesProp[1];
        this.taxRatesAlreadyEncoded = false;
      } else {
        this.taxRatesString = null;
        this.taxRatesAlreadyEncoded = false;
      }

      // Decode for use, but keep the original strings
      this.data = this.dataString ? this.decodeProperty("_data") : {};
      this.taxRates = this.taxRatesString
        ? this.decodeProperty("_taxRates")
        : [];

      // Set initial state based on the loaded data
      this.state = this.determineInitialState();
    } catch (error) {
      console.error("Error loading multiship form data:", error);
      this.setDefaultValues();
    }
  }

  /**
   * Helper to decode a property value using CartDataEncoder
   * @param {string} propertyName - The property name to find and decode
   * @returns {*} The decoded value or appropriate default
   */
  decodeProperty(propertyName) {
    const property = this.properties.find((prop) => prop[0] === propertyName);

    if (!property || !property[1]) {
      return propertyName === "_taxRates" ? [] : {};
    }

    if (!window.CartDataEncoder) {
      console.warn("CartDataEncoder not loaded, returning empty value");
      return propertyName === "_taxRates" ? [] : {};
    }

    return window.CartDataEncoder.decode(property[1]);
  }

  /**
   * Set default values when no data is available
   */
  setDefaultValues() {
    this.properties = [];
    this.originalProperties = [];
    this.data = {};
    this.dataString = null;
    this.taxRates = [];
    this.taxRatesString = null;
    this.taxRatesAlreadyEncoded = false;
    this.state = this.getDefaultState();
  }

  determineInitialState() {
    // To be implemented by child classes
    throw new Error("determineInitialState must be implemented by child class");
  }

  getDefaultState() {
    // To be implemented by child classes
    throw new Error("getDefaultState must be implemented by child class");
  }

  render() {
    let template = this.getTemplate();
    this.shadowRoot.innerHTML = `
      ${template}
    `;
    this.attachEventListeners();
  }

  getTemplate() {
    // To be implemented by child classes
    throw new Error("getTemplate must be implemented by child class");
  }

  attachEventListeners() {
    // To be implemented by child classes
    throw new Error(
      "attachEventListeners() must be implemented by child classes",
    );
  }

  showForm() {
    this.state = "form";
    this.render();
  }

  async handleSubmit() {
    try {
      await super.handleSubmit?.();

      // Find the form's container element
      const formContainer = this.closest(".bundle-recipients__section");
      if (formContainer) {
        formContainer.scrollIntoView({
          block: "center",
        });
      }
    } catch (error) {
      console.error("Error in form submission:", error);
      throw error;
    }
  }

  updateProperty(key, value) {
    const index = this.properties.findIndex((prop) => prop[0] === key);
    if (index !== -1) {
      this.properties[index][1] = value;
    } else {
      this.properties.push([key, value]);
    }
  }

  /**
   * Save data property intelligently to avoid double-encoding
   * @param {object} updatedData - The updated data object
   */
  saveDataProperty(updatedData) {
    // Check if the data object has actually changed from what we loaded
    const dataChanged =
      JSON.stringify(updatedData) !== JSON.stringify(this.data);

    if (!dataChanged && this.dataString) {
      // Data hasn't changed, use the original encoded string to avoid double-encoding
      this.updateProperty("_data", this.dataString);
    } else {
      // Data has changed, encode it fresh
      const encodedData = window.CartDataEncoder.encode(updatedData);
      this.updateProperty("_data", encodedData);
      // Update our stored references
      this.dataString = encodedData;
      this.data = updatedData;
    }
  }

  decodeAllProperties(properties) {
    return properties.map(([key, value]) => {
      if (typeof value === "string") {
        return [key, this.decodeHTMLEntities(value)];
      } else if (typeof value === "object" && value !== null) {
        return [key, this.decodeObjectRecursively(value)];
      }
      return [key, value];
    });
  }

  decodeHTMLEntities(str) {
    if (typeof str !== "string") return str;

    const textarea = document.createElement("textarea");
    let decoded = str;
    let previousValue;

    // Existing carts may contain more than one encoding layer (for example,
    // &amp;amp;). Normalize every layer before any property is sent back to
    // Shopify.
    do {
      previousValue = decoded;
      textarea.innerHTML = decoded;
      decoded = textarea.value;
    } while (decoded !== previousValue);

    return decoded;
  }

  // Escape HTML entities for safe insertion into HTML
  escapeHtml(str) {
    if (typeof str !== "string") return str || "";

    return str
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  decodeObjectRecursively(obj) {
    if (obj === null || obj === undefined) return obj;

    // Handle strings
    if (typeof obj === "string") {
      return this.decodeHTMLEntities(obj);
    }

    // Handle arrays
    if (Array.isArray(obj)) {
      return obj.map((item) => this.decodeObjectRecursively(item));
    }

    // Handle objects
    if (typeof obj === "object") {
      const decoded = {};
      for (const [key, value] of Object.entries(obj)) {
        decoded[key] = this.decodeObjectRecursively(value);
      }
      return decoded;
    }

    // Return primitives as-is
    return obj;
  }

  isPOBox(address) {
    const normalized = address
      .toLowerCase()
      .replace(/[^a-z0-9]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const poBoxRegex =
      /(\d+\s+)?(p\s*o\s*box|post\s*(office|box)|pobox|box\s*#?\d+)/gi;

    return poBoxRegex.test(normalized);
  }

  async updateCart(updatedProperties) {
    try {
      const propertiesWithTimestamp = {
        ...updatedProperties,
        _timestamp: Date.now(),
      };

      const decodedPropertiesWithTimestamp = propertiesWithTimestamp;
      const mergedProperties = this.prepareMergedProperties(
        decodedPropertiesWithTimestamp,
      );
      const quantity = parseInt(
        this.getAttribute("data-item-quantity") || "1",
        10,
      );
      const lineItemId =
        this.lineItemId || this.getAttribute("data-line-item-id");
      const lineNumber = this.getLineNumber();

      const identifier = lineItemId
        ? { id: lineItemId }
        : { line: Number.isNaN(lineNumber) ? 1 : lineNumber };

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          ...identifier,
          quantity: quantity,
          properties: mergedProperties,
          sections: ["main-cart-items"],
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to update cart: ${response.status} ${response.statusText}\n${errorText}`,
        );
      }

      const result = await response.json();

      // Notify other components that the cart was updated
      this.dispatchEvent(
        new CustomEvent("cartUpdated", {
          bubbles: true,
          composed: true,
          detail: { updatedCartHtml: result.sections },
        }),
      );

      return result;
    } catch (error) {
      console.error("Error updating cart:", error);
      throw error;
    }
  }

  /**
   * Prepare merged properties for cart update
   * Preserves bundle fields and handles primary item logic
   */
  prepareMergedProperties(updatedProperties) {
    const originalProps = Object.fromEntries(
      this.originalProperties || this.properties,
    );
    const currentProps = Object.fromEntries(this.properties);

    // Remove _taxRates from currentProps if this form doesn't handle taxes
    if (!this.handlesTaxes) {
      delete currentProps._taxRates;
    }

    // Start with preserved bundle fields
    const mergedProperties = this.getPreservedBundleFields(originalProps);

    // Add current properties (excluding primaryItem if not preserved and _taxRates if removed above)
    Object.assign(
      mergedProperties,
      this.getCleanedCurrentProperties(currentProps, mergedProperties),
    );

    // Add the updates
    Object.assign(mergedProperties, updatedProperties);

    // Use preserved encoded strings to prevent double-encoding
    if (!updatedProperties.hasOwnProperty("_data") && this.dataString) {
      mergedProperties._data = this.dataString;
    }

    // Special handling for _taxRates
    if (this.handlesTaxes) {
      // Address form - include _taxRates (either updated or preserved)
      if (
        !updatedProperties.hasOwnProperty("_taxRates") &&
        this.taxRatesString
      ) {
        mergedProperties._taxRates = this.taxRatesString;
      }
    } else if (this.taxRatesString) {
      // Other forms - include the cleaned string to maintain the property
      mergedProperties._taxRates = this.taxRatesString;
    }

    // Add timestamp for tracking
    mergedProperties._timestamp = Date.now();

    // Normalize again at the Cart API boundary. This protects properties that
    // were changed after load and repairs legacy values before they can gain
    // another encoding layer.
    return Object.fromEntries(
      this.decodeAllProperties(Object.entries(mergedProperties)),
    );
  }

  /**
   * Get bundle fields that should be preserved
   */
  getPreservedBundleFields(originalProps) {
    const bundleFields = {};

    // Preserve basic bundle fields
    ["_bundleId", "_isMergedBundle", "_bundleComponents", "bundleId"].forEach(
      (field) => {
        if (originalProps[field] !== undefined) {
          bundleFields[field] = originalProps[field];
        }
      },
    );

    // Handle primaryItem preservation logic
    const primaryItemValue = this.determinePrimaryItemValue(originalProps);
    if (primaryItemValue) {
      bundleFields["_primaryItem"] = primaryItemValue;
      bundleFields["primaryItem"] = primaryItemValue;
    }

    return bundleFields;
  }

  /**
   * Determine if this item should have primaryItem set
   */
  determinePrimaryItemValue(originalProps) {
    const wasMergedBundle = originalProps["_isMergedBundle"] === "true";
    const itemVariantId = this.getAttribute("data-variant-id");

    // Case 1: Originally a primary item (not from a merged bundle)
    if (
      !wasMergedBundle &&
      (originalProps["_primaryItem"] === "true" ||
        originalProps["primaryItem"] === "true")
    ) {
      return "true";
    }

    // Case 2: Was the primary variant in a merged bundle
    if (
      wasMergedBundle &&
      originalProps["_primaryVariantId"] ===
        `gid://shopify/ProductVariant/${itemVariantId}`
    ) {
      return "true";
    }

    // Case 3: Not a primary item
    return null;
  }

  /**
   * Get current properties cleaned of unwanted fields
   */
  getCleanedCurrentProperties(currentProps, preservedFields) {
    const cleaned = { ...currentProps };

    // Remove primaryItem if it wasn't preserved
    if (!preservedFields["_primaryItem"] && !preservedFields["primaryItem"]) {
      delete cleaned["_primaryItem"];
      delete cleaned["primaryItem"];
    }

    return cleaned;
  }

  /**
   * Get the line number for cart API (1-indexed)
   */
  getLineNumber() {
    return parseInt(
      this.getAttribute("data-line-number") ||
        this.getAttribute("data-index") ||
        "1",
      10,
    );
  }
}
